import React, { useState, useEffect } from 'react';
import { MDBContainer, MDBRow, MDBCol, MDBTypography } from 'mdb-react-ui-kit';
import '../styles/index.css';
import serviceImg2 from '../images/automation.png';
import serviceImg1 from '../images/installation.jpg';
import serviceImg3 from '../images/technical-design.jpg';
import AOS from 'aos';
import { useLanguage } from '../context/LanguageContext';

export default function About() {
    const { language } = useLanguage();
    
    AOS.init({
        offset: 200,
        duration: 600,
        easing: 'ease-in-sine',
        delay: 100,
    });

    return (
        <MDBContainer breakpoint="lg" className='about-container' id='about-container'>
            {/* About Us Section */}

            <MDBRow className='border-row' data-aos="fade-up">
                <MDBCol md='12' className='col-about text-start mb-0'>
                        <MDBTypography style={{ fontWeight: "600" }} tag='div' className='display-6 pb-3 mb-3 border-bottom'>
                            {language === 'EN' ? 'About Us' : 'Despre Noi'}
                        </MDBTypography>
                        <MDBTypography style={{textAlign: "justify"}} className='lead about-paragraph'>
                            {language === 'EN' ? (
                                <>
                                    Solexpres has over 25 years of experience in designing and delivering heating, 
                                    ventilation, and air conditioning systems. We create customized, smart-controlled 
                                    solutions tailored to each client and space, operating across the European Union and Moldova.
                                    <span style={{ color: "#50b9df", fontWeight: "600" }}> Your comfort is our specialty.</span>
                                </>
                            ) : (
                                <>
                                    Solexpres are peste 25 de ani de experiență în proiectarea și implementarea sistemelor de încălzire, 
                                    ventilație și aer condiționat. Realizăm soluții personalizate, controlate inteligent, 
                                    adaptate fiecărui client și fiecărui spațiu, operând pe întreg teritoriul Uniunii Europene și în Republica Moldova.
                                    <span style={{ color: "#50b9df", fontWeight: "600" }}> Confortul dumneavoastră este specialitatea noastră.</span>
                                </>
                            )}
                        </MDBTypography>
                </MDBCol>
            </MDBRow>

            {/* Services Section */}
            <MDBRow className='g-4 mt-4' data-aos="fade-up" data-aos-delay="200">
                {/* Technical Design */}
                <MDBCol md='4'>
                    <div className='text-center'>
                        <MDBTypography tag='h4' className='mb-3' style={{ fontWeight: '600', color: '#384159' }}>
                            {language === 'EN' ? 'Technical Design' : 'Proiectare Tehnică'}
                        </MDBTypography>
                        <img 
                            src={serviceImg3} 
                            className='img-fluid rounded shadow-sm' 
                            alt='Technical Design' 
                            style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                        />
                    </div>
                </MDBCol>

                {/* Installation */}
                <MDBCol md='4'>
                    <div className='text-center'>
                        <MDBTypography tag='h4' className='mb-3' style={{ fontWeight: '600', color: '#384159' }}>
                            {language === 'EN' ? 'Installation' : 'Instalare'}
                        </MDBTypography>
                        <img 
                            src={serviceImg1} 
                            className='img-fluid rounded shadow-sm' 
                            alt='Installation' 
                            style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                        />
                    </div>
                </MDBCol>

                {/* Automation */}
                <MDBCol md='4'>
                    <div className='text-center'>
                        <MDBTypography tag='h4' className='mb-3' style={{ fontWeight: '600', color: '#384159' }}>
                            {language === 'EN' ? 'Automation' : 'Automatizare'}
                        </MDBTypography>
                        <img 
                            src={serviceImg2} 
                            className='img-fluid rounded shadow-sm' 
                            alt='Automation' 
                            style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                        />
                    </div>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
}


// return (
//         <MDBContainer breakpoint="lg" className='about-container' id='about-container'>

//             <MDBRow /* style={{border: "none"}} */ className='border-row' data-aos="fade-up">
//                 <MDBCol md='12' className='col-about text-start mb-0'>
//                     <MDBTypography style={{fontWeight: "600"}} tag='div' className='display-6 pb-3 mb-3 border-bottom'>
//                         About Us
//                     </MDBTypography>
//                     <MDBTypography className='lead about-paragraph'>
//                         {/* Solexpres is a company with 20 years of experience
//                     in designing and building engineering systems in heating,
//                     ventilation and air conditioning. We create customized and smart-controlled solutions for each client and space.
//                     Your comfort is our specialty. */}
//                         Solexpres has over 25 years of experience in designing and delivering heating, 
//                         ventilation, and air conditioning systems. We create customized, smart-controlled 
//                         solutions tailored to each client and space, operating across the European Union and Moldova.
//                         <span style={{color: "#50b9df", fontWeight: "600"}}> Your comfort is our specialty.</span>
//                     </MDBTypography>
//                 </MDBCol>
//             </MDBRow>

//             {/* Services Section */}
//             <MDBRow className='g-4 mt-4' data-aos="fade-up" data-aos-delay="200">
//                 {/* Technical Design */}
//                 <MDBCol md='4'>
//                     <div className='text-center'>
//                         <MDBTypography tag='h4' className='mb-3' style={{ fontWeight: '600', color: '#384159' }}>
//                             Technical Design
//                         </MDBTypography>
//                         <img 
//                             src={serviceImg3} 
//                             className='img-fluid rounded shadow-sm' 
//                             alt='Technical Design' 
//                             style={{ width: '100%', height: '250px', objectFit: 'cover' }}
//                         />
//                     </div>
//                 </MDBCol>

//                 {/* Installation */}
//                 <MDBCol md='4'>
//                     <div className='text-center'>
//                         <MDBTypography tag='h4' className='mb-3' style={{ fontWeight: '600', color: '#384159' }}>
//                             Installation
//                         </MDBTypography>
//                         <img 
//                             src={serviceImg1} 
//                             className='img-fluid rounded shadow-sm' 
//                             alt='Installation' 
//                             style={{ width: '100%', height: '250px', objectFit: 'cover' }}
//                         />
//                     </div>
//                 </MDBCol>

//                 {/* Automation */}
//                 <MDBCol md='4'>
//                     <div className='text-center'>
//                         <MDBTypography tag='h4' className='mb-3' style={{ fontWeight: '600', color: '#384159' }}>
//                             Automation
//                         </MDBTypography>
//                         <img 
//                             src={serviceImg2} 
//                             className='img-fluid rounded shadow-sm' 
//                             alt='Automation' 
//                             style={{ width: '100%', height: '250px', objectFit: 'cover' }}
//                         />
//                     </div>
//                 </MDBCol>
//             </MDBRow>
//         </MDBContainer>
//     );